module.exports = __webpack_public_path__ + "img/-2_1.e42779e3.svg";